import Vue from 'vue'
import store from '@/store'

Vue.directive('number', {
  inserted: (el, binding) => {
    el.addEventListener('keydown', (event) => {
      const { arg } = binding
      const { key } = event
      if(arg == 'number' && ['+', 'e'].includes(key)) {
        event.preventDefault()
      }
    })
  }
})
Vue.directive('tooltip', {
  bind(el, binding) {
    let tooltip = document.getElementById('vc-tooltip')

    if (!tooltip) {
      tooltip = document.createElement('div')
      tooltip.id = 'vc-tooltip'
      tooltip.className = 'vc-tooltip hidden'
      document.body.appendChild(tooltip)

      // 添加箭头
      const arrow = document.createElement('div')
      arrow.className = 'arrow'
      tooltip.appendChild(arrow)
    }

    el._tooltipElement = tooltip
    updateTooltip(el, binding)

    // 鼠标移入事件
    el._tooltipHandler = function(e) {
      showTooltip(el, e)
    }

    // 鼠标移出事件
    el._tooltipHideHandler = function() {
      hideTooltip(el)
    }

    // 添加事件监听
    el.addEventListener('mouseenter', el._tooltipHandler)
    el.addEventListener('mouseleave', el._tooltipHideHandler)
    el.addEventListener('touchstart', el._tooltipHandler, { passive: true })
    el.addEventListener('touchend', el._tooltipHideHandler)
  },

  update(el, binding) {
    // 数据更新时调用
    updateTooltip(el, binding)

    // 如果当前正在显示tooltip，则更新显示内容
    if (el._tooltipElement.classList.contains('visible')) {
      showTooltip(el, { clientX: el._lastX, clientY: el._lastY })
    }
  },

  unbind(el) {
    // 清理事件监听
    el.removeEventListener('mouseenter', el._tooltipHandler)
    el.removeEventListener('mouseleave', el._tooltipHideHandler)
    el.removeEventListener('touchstart', el._tooltipHandler)
    el.removeEventListener('touchend', el._tooltipHideHandler)

    // 清理引用
    el._tooltipElement = null
  }
})
// 更新tooltip内容
function updateTooltip(el, binding) {
  // 处理绑定值
  el._tooltipOptions = typeof binding.value === 'string'
    ? { content: binding.value }
    : binding.value
}

// 显示tooltip
function showTooltip(el, e) {
  const tooltip = el._tooltipElement
  const options = el._tooltipOptions

  // 存储最后的位置（用于更新时重新定位）
  el._lastX = e.clientX
  el._lastY = e.clientY

  tooltip.innerHTML = options.content

  // 应用主题
  tooltip.className = 'vc-tooltip hidden'
  if (options.theme && options.theme !== 'default') {
    tooltip.classList.add(options.theme)
  }

  // 计算位置
  const rect = tooltip.getBoundingClientRect()
  const width = rect.width
  const height = rect.height

  let top = e.clientY + 10
  let left = e.clientX - width / 2

  // 边界检测
  if (left < 10) left = 10
  if (left + width > window.innerWidth - 10) {
    left = window.innerWidth - width - 10
  }

  if (top + height > window.innerHeight - 10) {
    top = e.clientY - height - 10
  }
  // 设置位置
  tooltip.style.left = left + 'px'
  tooltip.style.top = top + 'px'

  // 显示tooltip
  tooltip.classList.remove('hidden')
  tooltip.classList.add('visible')
}

// 隐藏tooltip
function hideTooltip(el) {
  const tooltip = el._tooltipElement
  tooltip.classList.remove('visible')
  tooltip.classList.add('hidden')
}

Vue.directive('copy',{
  /*
    bind 钩子函数，第一次绑定时调用，可以在这里做初始化设置
    el: 作用的 dom 对象
    value: 传给指令的值，也就是我们要 copy 的值
  */

  bind(el, { value }) {
    el.$value = value // 用一个全局属性来存传进来的值，因为这个值在别的钩子函数里还会用到
    let keyAltDown = false
    el.style.position = 'relative'
    let tip = document.createElement('span')
    tip.className = 'tooltip'
    // 提示框样式
    let css = {
      display: 'none',
      position: 'absolute',
      //   width: "100%",
      padding: '5px 8px',
      borderRadius: '6px',
      color: 'white',
      fontSize:'14px',
      fontWeight:'400',
      lineHeight:'18px',
      backgroundColor: '#24292E',
      textAlign: 'center',
      zIndex: 9999
    }
    let pos = setPosition(tip)
    for (const item in pos) {
      css[item] = pos[item]
    }
    setCss(tip, css)
    el.appendChild(tip)
    el.addEventListener('mouseover', ()=>{
      if(keyAltDown&&value){
        let copyVal = store.state.copy.keyAltDownCopyVal
        tip.textContent = copyVal == value?'Copy!':'Copy to Clipboard'
        tip.style.display = 'block'
      }
    })
    el.addEventListener('mouseout', ()=>{
      tip.style.display = 'none'
    })
    el.handler = () => {
      if(keyAltDown){
        if (!el.$value) {
          tip.style.display = 'none'
          return
        }
        tip.style.display = 'none'
        el.removeChild(tip)
        // 动态创建 textarea 标签
        const textarea = document.createElement('textarea')
        textarea.value = el.$value
        // 将 textarea 插入到 body 中
        document.body.appendChild(textarea)
        // 选中值并复制
        textarea.select()
        // textarea.setSelectionRange(0, textarea.value.length);
        const result = document.execCommand('Copy')
        document.body.removeChild(textarea)
        if (result) {
          tip.textContent = 'Copy!'
          tip.style.display = 'block'
          textarea.value = el.$value
          store.dispatch('copy/setKeyAltDownCopyVal',el.$value)
          setTimeout(()=>{
            el.appendChild(tip)
          },0)
        }
      }
    }
    // 绑定点击事件，就是所谓的一键 copy 啦
    document.body.addEventListener('keydown', (event)=>{
      if(event.keyCode == 18){
        keyAltDown = true
        el.classList.add('key-alt-down')
      }
    })
    document.body.addEventListener('keyup', (event)=>{
      keyAltDown = false
      tip.style.display = 'none'
      el.classList.remove('key-alt-down')
      // store.dispatch('copy/setKeyAltDownCopyVal',null)

    })
    el.addEventListener('click', el.handler)
  },
  // 当传进来的值更新的时候触发
  componentUpdated(el, { value }) {
    el.$value = value
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    el.classList.remove('key-alt-down')
    store.dispatch('copy/setKeyAltDownCopyVal',null)
    el.removeEventListener('click', el.handler)
  },
})

// 给元素赋值样式
function setCss(obj, css) {
  for (const attr in css) {
    obj.style[attr] = css[attr]
  }
}
// 设置提示框位置样式
function setPosition(tip, pos, color) {
  switch (pos) {
    case 'bottom':
      tip.className += ' bottom'
      document.styleSheets[0].insertRule(
        `.tooltip.bottom:before{
          content: '';
          position: absolute;
          top: -5px;
          left: 50%;
          transform: translateX(-50%);
          border-bottom: 5px solid black;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
      }`,
        0
      )
      return {
        bottom: '-5%',
        left: '50%',
        transform: 'translateX(-50%) translateY(130%)'
      }
      break
    //top
    default:
      tip.className += ' top'
      document.styleSheets[0].insertRule(
        `.tooltip.top:before{
        content: '';
        position: absolute;
        bottom: -4px;
        left: 12px;
        transform: translateX(-50%);
        border-top: 5px solid #24292E;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
    }`,
        0
      )
      return {
        top: '-5%',
        left: '0',
        transform: 'translateX(0) translateY(-130%)'
      }
      break
  }
}
